(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.contact-telephone', ['pp.widgets-templates']);

ngModule.component('ppContactTelephone', {
    templateUrl: 'widgets/_angular/contact-telephone/contact-telephone.tpl.html',
    bindings: {},
    controllerAs: 'vm',
    controller: ['$scope', function ($scope) {
        var vm = this;

        // -- initial state

        // -- util functions

        // -- api

        // -- scope bindings

        // -- main

    }]
});
})(window, window.angular);